import type { Feature } from '@hotjar/webapp/domains/common/feature/types';
import type { CamelCasedPropertiesDeep } from 'type-fest';
import type { Account as AccountDto } from './dto';

export type Access = 'admin' | 'write' | 'read';

export type AccountType = 'agency' | 'individual';

export type BillingCycle = 'monthly' | 'yearly_recurring' | 'yearly' | 'lifetime';

export type Currency = 'eur' | 'usd';

export type Features = Feature[];

export type PaymentMethods = 'credit_card' | 'paypal' | string;

export interface RegistrationCampaign {
  numFreeDays: number;
  plan?: string;
  planId: string | null;
  sampleRate?: number | null;
}

export enum TrialState {
  ELIGIBLE = 'trial_eligible',
  ACTIVE = 'trial_active',
  EXPIRED = 'trial_expired',
}

export interface AccountTrialInfo {
  campaign: RegistrationCampaign | null;
  daysRemaining: number | null;
  state: TrialState | null;
  timeUntilExpiry: string | null;
  activeOrEligible: boolean;
  active: boolean;
}

export type AccountId = number;

/**
 * @deprecated
 */
export type Account = CamelCasedPropertiesDeep<AccountDto>;
